<script>
    import { Line } from "svelte-chartjs";

    import {
        Chart,
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        PointElement,
        CategoryScale,
    } from "chart.js";

    Chart.register(
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        PointElement,
        CategoryScale,
    );

    export let labelArr = [],
        chartData = [];

    const lineData = {
        label: "",
        data: [],
        fill: true,
        lineTension: 0.3,
        borderCapStyle: "butt",
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderWidth: 5,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
    };

    const data = {
        labels: [],
        datasets: [],
    };

    const options = {
        scales: {
            yAxis: {
                min: 0,
            },
        },
    };

    const colorArr = [
        "rgba(251, 60, 186, 1)",
        "rgba(251, 212, 8, 1)",
        "rgba(7, 208, 3, 1)",
        "rgba(20, 184, 194, 1)",
        "rgba(97, 20, 194, 1)",
        "rgba(20, 90, 194, 1)",
        "rgba(30, 40, 130, 1)",
    ];

    $: formatChartData(chartData);

    const formatChartData = () => {
        data.labels = [];
        data.datasets = [];

        if (chartData.length)
            chartData.map((cd, index) => {
                data.labels = cd.label;
                data.datasets.push({
                    ...lineData,
                    data: [...cd.data],
                    label: labelArr[index] ?? "",
                    borderColor: colorArr[index],
                    backgroundColor: colorArr[index],
                    pointBackgroundColor: colorArr[index],
                });
            });
    };
</script>

<div>
    {#if chartData.length == 0}
        <div class="flex-1 items-center text-center">No data</div>
    {:else}
        <Line {data} {options} width="100" height="20" />
    {/if}
</div>
